module.exports = "/assets/ff9e09cf4c97dbd776c0f2ffcba1c056.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/TQ.png
// module id = 1865
// module chunks = 0